import { Month } from "PFApp/booking/parts/overview/context/use_calendar_days";
import { Typography } from "PFComponents/typography";
import React from "react";

import { StickyItem } from "../sticky_item";
import css from "./months.module.scss";

const MIN_MONTH_WIDTH = 75;

type MonthItemProps = {
  month: Month;
};

export const MonthItem = ({ month }: MonthItemProps): JSX.Element => {
  const { label, left, width } = month;
  const shouldDisplayLabel = width > MIN_MONTH_WIDTH;

  return (
    <div className={css.month} style={{ width, left }} key={label} title={label}>
      {shouldDisplayLabel && (
        <StickyItem>
          <Typography variant="bodyBold" tag="span">
            {label}
          </Typography>
        </StickyItem>
      )}
    </div>
  );
};
